// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import dayjs from 'E:/geo/geo_web/view/myapp/node_modules/dayjs';
import antdPlugin from 'E:/geo/geo_web/view/myapp/node_modules/antd-dayjs-webpack-plugin/src/antd-plugin.js';

import isSameOrBefore from 'E:/geo/geo_web/view/myapp/node_modules/dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'E:/geo/geo_web/view/myapp/node_modules/dayjs/plugin/isSameOrAfter';
import advancedFormat from 'E:/geo/geo_web/view/myapp/node_modules/dayjs/plugin/advancedFormat';
import customParseFormat from 'E:/geo/geo_web/view/myapp/node_modules/dayjs/plugin/customParseFormat';
import weekday from 'E:/geo/geo_web/view/myapp/node_modules/dayjs/plugin/weekday';
import weekYear from 'E:/geo/geo_web/view/myapp/node_modules/dayjs/plugin/weekYear';
import weekOfYear from 'E:/geo/geo_web/view/myapp/node_modules/dayjs/plugin/weekOfYear';
import isMoment from 'E:/geo/geo_web/view/myapp/node_modules/dayjs/plugin/isMoment';
import localeData from 'E:/geo/geo_web/view/myapp/node_modules/dayjs/plugin/localeData';
import localizedFormat from 'E:/geo/geo_web/view/myapp/node_modules/dayjs/plugin/localizedFormat';
import duration from 'E:/geo/geo_web/view/myapp/node_modules/dayjs/plugin/duration';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(weekYear);
dayjs.extend(weekOfYear);
dayjs.extend(isMoment);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(duration);

dayjs.extend(antdPlugin);
